const SYMBOLS = []

export default SYMBOLS
